import { Options } from './types';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { Response as ResponsePolyfill } from 'whatwg-fetch';

export function delay(timeMS = 0) {
    return new Promise((resolve) => {
        setTimeout(resolve, timeMS);
    });
}

export function randomIntBetween(from: number, to: number) {
    return Math.floor(from + Math.random() * (to - from + 1));
}

const LS_NAME = 'MOCK_INFO';

export function shouldPassThrough(mockName: string, type: 'http' | 'graphql') {
    const storage = localStorage.getItem(LS_NAME);
    if (!storage) return false;
    const { ignore, mode } = JSON.parse(storage) as Options;
    if (mode === 'all-enabled' || !ignore) return false;
    return type === 'graphql'
        ? ignore.includes(mockName)
        : ignore.some((i) => mockName.includes(i));
}

export function getData<TData>() {
    const data = localStorage.getItem(LS_NAME);
    return data ? (JSON.parse(data) as TData) : null;
}

export function removeData() {
    localStorage.removeItem(LS_NAME);
}

export function setData(data: Options) {
    const prevData = getData<Options>();
    localStorage.setItem(LS_NAME, JSON.stringify({ ...prevData, ...data }));
}

export const statuses = {
    200: 'OK',
    204: 'No Content',
    400: 'Bad Request',
    401: 'Not Authorized',
    403: 'Forbidden',
    404: 'Not Found',
    422: 'Unprocessable Entity',
    429: 'Too Many Requests',
    500: 'Internal Server Error',
    502: 'Bad Gateway',
    504: 'Gateway Timeout',
} as const;

export function mockedResponse(params: {
    status: keyof typeof statuses;
    statusText?: string;
    headers?: any;
    body: any;
}) {
    const {
        status = 200,
        statusText = statuses[status],
        body = {},
        headers = {},
    } = params;
    const Res = typeof Response === 'undefined' ? ResponsePolyfill : Response;

    return new Res(body ? JSON.stringify(body) : null, {
        status,
        statusText,
        headers: { 'Content-type': 'application/json', ...headers },
    });
}

export function getMockOverride(key: string) {
    const storage = localStorage.getItem(LS_NAME);
    if (!storage) return null;
    const { overrides } = JSON.parse(storage) as Options;
    return overrides ? overrides[key] || null : null;
}

export function getMockedToken(type: string) {
    const storage = localStorage.getItem(LS_NAME);
    if (!storage) return null;
    const { application_token, borrower_token } = JSON.parse(
        storage
    ) as Options;
    if (type === 'application' && application_token) return application_token;
    if (type === 'borrower' && borrower_token) return borrower_token;
    return null;
}

export function isApplicationEmpty() {
    const storage = localStorage.getItem(LS_NAME);
    if (!storage) return null;
    const parsed = JSON.parse(storage) as Options;
    return parsed?.applicationEmpty;
}
